import React from 'react';
import { Image } from '@wix/design-system';
import { useResizeImage } from '../../hooks/image-resize';

export function AppIcon({
  iconUrl,
  appName,
  className,
  size = 'small',
}: {
  iconUrl: string;
  appName: string;
  className: string;
  size?: 'small' | 'medium';
}) {
  const resizeImage = useResizeImage();
  return (
    <Image
      height={size === 'small' ? '42px' : '54px'}
      width={size === 'small' ? '42px' : '54px'}
      alt={`${appName} icon`}
      src={resizeImage({
        imageUrl: iconUrl,
        originalHeight: 974,
        originalWidth: 974,
        toHeight: size === 'small' ? 42 : 54,
        toWidth: size === 'small' ? 42 : 54,
      })}
      className={className}
    />
  );
}
